module.exports = __webpack_public_path__ + "static/img/subcontract1.23bad704.png";